<template>
  <v-navigation-drawer v-model="drawer" app color="grey lighten-4">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          <router-link :to="'/'">
            <div class="text-center mb-5">
              <img :src="logo" alt="Logo" width="100" />
            </div>
          </router-link>
        </v-list-item-title>
        <v-list-item-subtitle>
          <v-divider></v-divider>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list dense nav>
      <template v-for="(item, i) in items">
        <template
          v-if="
            $ability.can(item.acesso, item.area) || getPapel == 'Administrador'
          "
        >
          <v-list-item v-if="!item.children" :key="item.text + i" :to="item.to" color="red" link>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            v-else-if="item.children"
            :prepend-icon="item.icon"
            :key="item.text + i"
            color="red"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </template>

            <template v-for="(children, i) in item.children">
              <v-list-item
                v-if="
                  $ability.can(children.acesso, children.area) ||
                    getPapel == 'Administrador'
                "
                :key="children.text + i"
                :to="children.to"
                link
                class="list-item-group"
                color="red"
              >
                <v-list-item-icon>
                  <v-icon size="7">mdi-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ children.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
        </template>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CoreDrawer",

  data() {
    return {
      logo: "/img/Logo.png",

      items: [
        //Dashboard
        {
          area: "Dashboard",
          acesso: "Visualizar",
          icon: "mdi-view-dashboard",
          text: "Dashboard",
          to: "/"
        },

        //App Analytics
        {
          area: "Usuarios",
          acesso: "Visualizar",
          icon: "mdi-cellphone-information",
          text: "App Analytics",
          to: "/AppAnalytics"
        },

        //Empresa
        {
          area: "Empresa",
          acesso: "Visualizar",
          icon: "mdi-office-building",
          text: "Empresa",
          children: [
            {
              area: "Empresas",
              acesso: "Visualizar",
              text: "Empresas",
              to: "/empresa/empresas"
            },
            {
              area: "Equipes",
              acesso: "Visualizar",
              text: "Equipes",
              to: "/empresa/equipes"
            },
            {
              area: "Colaboradores",
              acesso: "Visualizar",
              text: "Colaboradores",
              to: "/empresa/colaboradores"
            },
            {
              area: "Parametros",
              acesso: "Visualizar",
              text: "Parametros",
              to: "/empresa/parametros"
            }
          ]
        },

        //Comercial
        {
          area: "Comercial",
          acesso: "Visualizar",
          icon: "mdi-store",
          text: "Comercial",
          children: [
            {
              area: "Financiamento",
              acesso: "Visualizar",
              text: "Financiamento",
              to: "/comercial/financiamento"
            },
            {
              area: "Consorcio",
              acesso: "Visualizar",
              text: "Consorcio",
              to: "/comercial/consorcio"
            },
            {
              area: "Adimplência",
              acesso: "Visualizar",
              text: "Adimplência",
              to: "/comercial/adimplencia"
            },
            {
              area: "Inadimplência",
              acesso: "Visualizar",
              text: "Inadimplência",
              to: "/comercial/inadimplencia"
            },
            {
              area: "Retenção",
              acesso: "Visualizar",
              text: "Retenção",
              to: "/comercial/retencao"
            }
          ]
        },

        //Veiculos
        {
          area: "Veiculos",
          acesso: "Visualizar",
          icon: "mdi-car-back",
          text: "Veiculos",
          to: "/veiculos"
        },

        //Produto Força
        {
          area: "Produto Forca",
          acesso: "Visualizar",
          icon: "mdi-engine",
          text: "Produto Força",
          to: "/produtoForca"
        },

        //Leads
        {
          area: "Leads",
          acesso: "Visualizar",
          icon: "mdi-filter",
          text: "Leads",
          children: [
            {
              area: "Gerenciar",
              acesso: "Visualizar",
              text: "Gerenciar",
              to: "/leads/gerenciar"
            },
            {
              area: "FormularioCaptura",
              acesso: "Visualizar",
              text: "Formulario de Captura",
              to: "/leads/formularioCaptura"
            }
          ]
        },

        //Materiais
        {
          area: "Materiais",
          acesso: "Visualizar",
          icon: "mdi-file-document",
          text: "Materiais",
          children: [
            {
              area: "Campanhas",
              acesso: "Visualizar",
              text: "Campanhas",
              to: "/materiais/campanhas"
            },
            {
              area: "Layouts",
              acesso: "Visualizar",
              text: "Layouts",
              to: "/materiais/layouts"
            },
            /*Desativado temporariamente*/
            {
              area: "Arquivos",
              acesso: "Visualizar",
              text: "Arquivos",
              to: "/materiais/arquivos"
            },
            {
              area: "Scripts",
              acesso: "Visualizar",
              text: "Scripts",
              to: "/materiais/scripts"
            }
          ]
        },

        //Notificação
        {
          area: "Notificacao",
          acesso: "Visualizar",
          icon: "mdi-cellphone-message",
          text: "Notificação",
          to: "/notificacao"
        },
        //Usuarios
        {
          area: "Usuarios",
          acesso: "Visualizar",
          icon: "mdi-account-multiple",
          text: "Usuários",
          to: "/usuarios"
        },

        //Menus
        {
          area: "Menus",
          acesso: "Visualizar",
          icon: "mdi-microsoft-xbox-controller-menu",
          text: "Menus",
          to: "/menus"
        },

        //Papeis
        {
          area: "Papeis",
          acesso: "Visualizar",
          icon: "mdi-shield-key",
          text: "Papeis",
          to: "/papeis"
        },

        //Sincronizações
        {
          area: "Sincronizações",
          acesso: "Visualizar",
          icon: "mdi-autorenew",
          text: "Sincronizações",
          to: "/sincronizacoes"
        },

        //Relatorios
        {
          area: "Relatorios",
          acesso: "Visualizar",
          icon: "mdi-file-chart",
          text: "Relatorios",
          children: [
            {
              area: "Colaborador x Usuario",
              acesso: "Visualizar",
              text: "Colaborador x Usuario",
              to: "/relatorios/colaborador-usuario"
            },
            {
              area: "Desempenho",
              acesso: "Visualizar",
              text: "Desempenho",
              to: "/relatorios/desempenho"
            }
          ]
        },

        //Procedures
        {
          area: "Procedures",
          acesso: "Visualizar",
          icon: "mdi-cogs",
          text: "Procedures",
          to: "/procedures"
        }
      ]
    };
  },

  computed: {
    ...mapGetters("app", ["getDrawer", "getAppBarColor"]),
    ...mapGetters("auth", ["getPapel"]),

    drawer: {
      get() {
        return this.getDrawer;
      },
      set(v) {
        this.setDrawer(v);
      }
    }
  },

  methods: {
    ...mapActions("login", ["doLogout"]),
    ...mapActions("app", ["setDrawer"]),
    ...mapActions("auth", ["signOut"])
  }
};
</script>

<style lang="scss">
#keep .v-navigation-drawer__border {
  display: none;
}

.list-item-group {
  margin-left: 7px;
}
</style>
